import $ from 'jquery';

export const questionCard = function (){
	$('.cp-QuizCard_Option').on('click', function(){
		let parent = $(this).parents('.cp-QuizCard');
		// console.log(this);
		if ($(this).hasClass('Yes')) {
			// console.log('it has a class of yes!');
			parent.find('.cp-QuizCard_Image').addClass('js-RotateRight');
		} else {
			// console.log('it has a class of no!');
			parent.find('.cp-QuizCard_Image').addClass('js-RotateLeft');
		}
		parent.addClass('js-CardComplete');

	});

	$('.cp-QuizCard:first-child').find('.cp-QuizCard_OptionSelectWrap label').on('click', function(){
		// console.log('last clicked');
		$('.tp-MatchMe_Form').submit();
	});

}